export const apiAuthorizationConfig = {
    endpoint: '/',
    applicationName: 'TheSchoolYear',
};